import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { UserProvider } from "@/lib/userContext";
import HomePage from "@/pages/HomePage";
import QuestionnairePage from "@/pages/QuestionnairePage";
import PreviewPage from "@/pages/PreviewPage";
import ProductSelectionPage from "@/pages/ProductSelectionPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmedPage from "@/pages/OrderConfirmedPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ContactPage from "@/pages/ContactPage";
import { PageMetadata } from "@/components/PageMetadata";
const AdminLoginPage = lazy(() => import("@/pages/AdminLoginPage"));
const AdminDashboardPage = lazy(() => import("@/pages/AdminDashboardPage"));
const AdminOrderDetailPage = lazy(() => import("@/pages/AdminOrderDetailPage"));

function App() {
  return (
    <div className="App">
      <UserProvider>
        <BrowserRouter>
          <PageMetadata/>
          <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a>
          <Suspense fallback={<p role="status" className="p-10" data-testid="route-loading">Opening your book…</p>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/create/:projectId" element={<QuestionnairePage />} />
            <Route path="/preview/:projectId" element={<PreviewPage />} />
            <Route path="/product/:projectId" element={<ProductSelectionPage />} />
            <Route path="/checkout/:projectId" element={<CheckoutPage />} />
            <Route path="/order/:orderId" element={<OrderConfirmedPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/orders/:orderId" element={<AdminOrderDetailPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </UserProvider>
    </div>
  );
}

export default App;
